<template>
  <model-table
    :collection="registerClients"
    :show-filter="false"
    :show-add="false"
    :columns="[
      { field: 'id' },
      { field: 'registerStation', component: 'model' },
      { name: 'Stripe Terminal Serial Number', field: 'effectiveStripeTerminalSerialNumber', component: 'chip' },
      { field: 'lastOnline', component: 'date-time' },
      { field: 'indyVersion', component: 'chip' },
      { field: 'electronVersion', component: 'chip' },
      { field: 'isElectronMode', component: 'checkbox' }
    ]"
    @row-clicked="((row) => $refs.registerClientDialog.show(row))"
  >
    <register-client-dialog ref="registerClientDialog" />
  </model-table>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import RegisterClientDialog from 'src/modules/admin/register-station/RegisterClientDialog'

export default {
  name: 'RegisterStationTable',
  components: {
    ModelTable,
    RegisterClientDialog
  },
  props: {
    registerStationId: {
      type: Number,
      default: null,
      required: false
    }
  },
  models: {
    registerClients: {
      status: true,
      variables () {
        return {
          registerStationId: this.registerStationId,
          connected: _.isNil(this.registerStationId) ? true : null,
          noCount: true
        }
      }
    }
  }
}
</script>
